export default __webpack_public_path__ + "static/media/Group1626@2x.771384a0.png";